import { render, staticRenderFns } from "./InvoiceContent.vue?vue&type=template&id=504df6c2&scoped=true&"
import script from "./InvoiceContent.vue?vue&type=script&lang=js&"
export * from "./InvoiceContent.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceContent.vue?vue&type=style&index=0&id=504df6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504df6c2",
  null
  
)

export default component.exports